
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchMetadatas } from 'actions'
import SetupFinish from '../../components/warehouse-setup-finish'
import { getWarehouseMetadataById } from 'selectors'
import getProp from '@f/get-prop'

class WarehouseSetupFinishContainer extends Component {
  render () {
    return (
      <SetupFinish
        workspaceSlug={this.props.workspaceSlug}
        isRequestingBITools={this.props.isRequesting}
        didFailToRequestBITools={this.props.didRequestFail}
        bitools={this.props.bitools}
        warehouseName={this.props.warehouseName}
        warehouseLogo={this.props.warehouseLogo}
        onFinishClick={this.props.hideWarehouseSetup} />
    )
  }

  componentDidMount () {
    this.props.fetchBITools()
  }
}

/**
 * State -> props.
 */

function mapStateToProps (state) {
  // TODO: selectors
  const { metadatasBySlug, application } = state
  const { isRequesting, didRequestFail, data } = metadatasBySlug.bitool
  const bitools = []
  for (const slug in data) {
    bitools.push(data[slug].data)
  }

  const { databaseId } = application.warehouseSetup
  const database = getWarehouseMetadataById(state, databaseId)
  const warehouseName = getProp('name', database)
  const warehouseLogo = getProp('logos.default', database)

  return {
    isRequesting,
    didRequestFail,
    bitools,
    warehouseName,
    warehouseLogo
  }
}

/**
 * Dispatch -> props.
 */

function mapDispatchToProps (dispatch) {
  return {
    fetchBITools: () => dispatch(fetchMetadatas({ metadataType: 'bitool' })),
    hideWarehouseSetup: () => window.location.reload()
  }
}

WarehouseSetupFinishContainer.displayName = 'WarehouseSetupFinishContainer'

WarehouseSetupFinishContainer.propTypes = {
  bitools: PropTypes.array.isRequired,
  didRequestFail: PropTypes.bool.isRequired,
  fetchBITools: PropTypes.func.isRequired,
  hideWarehouseSetup: PropTypes.func.isRequired,
  isRequesting: PropTypes.bool.isRequired,
  warehouseLogo: PropTypes.string.isRequired,
  warehouseName: PropTypes.string.isRequired,
  workspaceSlug: PropTypes.string.isRequired
}

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseSetupFinishContainer)



// WEBPACK FOOTER //
// ./pages/workspace-warehouses/containers/warehouse-setup-finish/index.js